import jwtDecode from 'jwt-decode';

export class TokenStorage {
  constructor() {
    this.token_name = 'customerJWT';
    this.pass_key = 'http://rps:data';
  }

  getToken = () => localStorage[this.token_name];
  setToken(token) {
    localStorage.setItem(this.token_name, token);
  }
  getCredentials() {
    const token = this.getToken();
    if (!token) return {};
    return jwtDecode(token);
  }
  getPayload() {
    const credentials = this.getCredentials();
    return {
      ...credentials[this.pass_key],
      username: credentials.preferred_username,
      exp: credentials.exp,
      email: credentials.email,
    };
  }
  removeToken() {
    localStorage.removeItem(this.token_name);
  }
  isValid = () => {
    const token = this.getToken();
    if (!token) return false;
    const credentials = jwtDecode(token);
    return !(credentials?.exp < Date.now() / 1000);
  };
}
